<template>
  <div class="width__50">
    <el-select
      v-model="lockedUserDeptRole"
      value-key="id"
      class="selector"
      size="medium"
      filterable
      @change="searchDeactivatedUserDeptRole"
    >
      <el-option
        v-for="item in userDeptRoles_"
        :key="item.id"
        :label="buildUserDeptRoleLabel(item)"
        :value="item"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
import constants from "../../constants";
import { EventBus } from "../../event-bus";
import userDeptRoleViewService from "../../services/userDeptRoleViewService";
import errorMessageFilter from "../../filters/errorMessageFilter";

export default {
  name: "locked-role-select-branch",
  data() {
    return {
      lockedUserDeptRole: null,
      userDeptRoles_: null,
      user_: null
    };
  },
  created() {
    this.user_ = this.$store.getters.user;
    this.lockedUserDeptRole = this.$store.getters.lockedUserDeptRole;
    this.list(this.user_.id);
  },

  computed: {
    userDeptRoleId_() {
      return this.$store.getters.lockedUserDeptRole;
    }
  },

  watch: {
    userDeptRoleId_(newValue) {
      if (newValue) {
        this.lockedUserDeptRole = newValue;
      }
    }
  },

  methods: {
    initUserDeptRoles(userDeptRoles) {
      this.userDeptRoles_ = [];
      this.userDeptRoles_.push(...(userDeptRoles || []));
      this.userDeptRoles_.sort((item1, item2) => {
        return this.buildUserDeptRoleLabel(item1).localeCompare(
          this.buildUserDeptRoleLabel(item2)
        );
      });
      console.log(this.userDeptRoles_);
    },

    registerUserDeptRoleChangeListener() {
      EventBus.$on(
        constants.EVENT_BUS.CHANGE_USER_DEPT_ROLE,
        options => (this.lockedUserDeptRole = options.lockedUserDeptRole)
      );
    },

    buildUserDeptRoleLabel(userDeptRole) {
      return userDeptRole.positionName + " " + userDeptRole.deptName;
    },
    searchDeactivatedUserDeptRole() {
      this.$store.commit("setUserDeptRoleLocked", this.lockedUserDeptRole);
      switch (this.lockedUserDeptRole.positionName) {
        case "Văn thư":
          // console.log("this.userDeptRoleId");
          // console.log(this.userDeptRoleId);
          // console.log("emit VT");
          this.$emit("searchDocVT");
          break;
        default:
          // console.log("this.userDeptRoleId");
          // console.log(this.userDeptRoleId);
          // console.log("emit CV");
          this.$emit("searchDocCV");
          break;
      }
    },

    handleUserDeptRoleNotExists() {
      this.content = errorMessageFilter({
        errorCode: "authenticate.userDeptRoleNotExists"
      });
      this.isOpenDialog = true;
    },

    list(userId) {
      return userDeptRoleViewService
        .findAllDeactiveUsersInDeptWithRole(userId)
        .then(response => {
          return new Promise((resolve, reject) => {
            if (response.data && response.data.length) {
              resolve(this.initUserDeptRoles(response.data));
            } else {
              this.handleUserDeptRoleNotExists();
              reject(
                new Error({ error: "authenticate.userDeptRoleNotExists" })
              );
            }
          });
        });
    }
  }
};
</script>

<style scoped>
.selector {
  width: 100% !important;
  color: #c0c4cc;
}
</style>



// WEBPACK FOOTER //
// src/views/common/locked-role-select-branch.vue